module.exports = __webpack_public_path__ + "img/button-glow.0942480f.png";